module.exports = __webpack_public_path__ + "img/3.7bf05c7b.png";